import { createApi, fetchBaseQuery, FetchBaseQueryError, BaseQueryFn, FetchArgs } from '@reduxjs/toolkit/query/react'
import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { msalInstance } from '../index'
import { setAlert } from '../source/slice/AlertSlice'
import i18n from '../config/i18n'

const scope: string = process.env.REACT_APP_SCOPE || ''
let sessionExpiredDispatched = false

const rawBaseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND_URL,
    prepareHeaders: async (headers) => {
        let account = msalInstance.getActiveAccount()
        if (!account) {
            const allAccounts = msalInstance.getAllAccounts()
            if (allAccounts.length > 0) {
                account = allAccounts[0]
                msalInstance.setActiveAccount(account)
            }
        }
        if (account) {
            try {
                const tokenResult = await msalInstance.acquireTokenSilent({
                    account,
                    scopes: [scope],
                })
                if (tokenResult?.accessToken) {
                    headers.set('Authorization', `Bearer ${tokenResult.accessToken}`)
                }
            } catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                    await msalInstance.acquireTokenRedirect({ account, scopes: [scope] })
                }
            }
        }
        return headers
    },
})

const baseQueryWith401Handler: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
    const result = await rawBaseQuery(args, api, extraOptions)
    if (result.error?.status === 401 && !sessionExpiredDispatched) {
        sessionExpiredDispatched = true
        api.dispatch(setAlert({ message: i18n.t('main.sessionExpired'), type: 'error' }))
        setTimeout(() => {
            sessionExpiredDispatched = false
        }, 5000)
    }
    return result
}

export const baseApi = createApi({
    reducerPath: 'api',
    baseQuery: baseQueryWith401Handler,

    tagTypes: ['Timecard', 'Journal', 'Projects', 'Report', 'ReportFAK', 'Templates', 'Orders'],
    endpoints: () => ({}),
})
